/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Ticketscapreached2Inputs */

const en_ticketscapreached2 = /** @type {(inputs: Ticketscapreached2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The sales limit of ${i?.limit} is reached. It goes away after your first event with paid tickets.`)
};

const de_ticketscapreached2 = /** @type {(inputs: Ticketscapreached2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Verkaufsgrenze von ${i?.limit} ist erreicht. Nach deinem ersten Event mit bezahlten Tickets fällt sie weg.`)
};

/**
* | output |
* | --- |
* | "The sales limit of {limit} is reached. It goes away after your first event with paid tickets." |
*
* @param {Ticketscapreached2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketscapreached2 = /** @type {((inputs: Ticketscapreached2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketscapreached2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketscapreached2(inputs)
	return de_ticketscapreached2(inputs)
});
export { ticketscapreached2 as "ticketsCapReached" }